import React from "react";
import { Input as AntInput } from "antd";
export default function Input({ value, onChange, placeholder="请输入", opts = {} }) {
  return <AntInput value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} {...opts}/>;
};
